import React, { useState, Fragment, useEffect } from 'react';
import add_box from '../images/add_box.svg';
import deleteImg from '../images/delete.svg';
import "../styles/Subscription_Upgrade.scss";
import Footer from './Footer';
import SideBar from './SideBar';
import Header from './Header';
import Modal from 'react-modal';
import close_black from '../images/close-black.svg';
import loader from '../images/loader.gif';
import '../styles/CommonStyle.scss';
import { useTranslation } from 'react-i18next';
import SuccessAlert from './SuccessAlert';
import ErrorAlert from './ErrorAlert';
import { getTenantPackage, getTenantTier, getTenantProduct, deleteTenantPackage, addTenantPackage } from '../services/tenant-identity-service';
import { getLocation } from '../services/branch-service';
import { getTokenDetailsByDecoding } from '../services/cookie-storage-service';

const Products = (props) => {

    let [alert_type, setAlertType] = useState("");
    let [alert_message, setAlertMessage] = useState('');
    let { t } = useTranslation();
    let [inputFields, setInputFields] = useState([
        // {
        //     locationGuid: '',
        //     productGuid: '',
        //     tierGuid: '',
        //     licenseCount: 0,
        //     userGuid: '',
        //     tenantGuid: '',
        //     packageGuid: ''
        // }
    ]);
    let [modalFields, setModalFields] = useState(
        {
            "productGuid": "string",
            "tierGuid": "string",
            "locationGuid": "string",
            "licenseCount": 0
        }
    );
    let [locationArr, setLocations] = useState([]);
    let [tierArr, setTier] = useState([]);
    let [productArr, setProduct] = useState([]);
    let [serverData, setServerData] = useState([]);
    let [isModalOpen, setModal] = useState(false);
    let [isConfirmModalOpen, setConfirmModal] = useState(false);
    let purchaseArr = [];

    useEffect(() => {
        let tenantGuid = getTokenDetailsByDecoding().tenantGuid;
        getPackage(tenantGuid);
        getLocations();
        getTier();
        getProduct();


        return () => {
            console.log('subscription unmount++++++++++++++++');
        };
    }, []);

    const handleChange = (event) => {
        const value = { ...modalFields };
        value[event.target.name] = event.target.value;
        setModalFields(value);
    }

    const increment = (event) => {
        const value = { ...modalFields };
        let oldVal = value.licenseCount;
        value['licenseCount'] = oldVal + 1;
        setModalFields(value);
    }

    const decrement = (event) => {
        const value = { ...modalFields };
        let oldVal = value.licenseCount;
        if (value.licenseCount > 0) {
            value['licenseCount'] = oldVal - 1;
        }
        else {
            value['licenseCount'] = 0;
        }

        setModalFields(value);
    }

    const clearAlertType = () => {
        setTimeout(() => {
            setAlertType('');
        }, 4000);
    }

    const addPackage = async (e) => {
        e.preventDefault();
        clearAlertType();
        let productArrResult = productArr.find(element => element.value.toUpperCase() === modalFields.productGuid.toUpperCase());

        let inputArr = [{
            'userGuid': props.auth.tenantUserGuid,
            'tenantGuid': props.auth.tenantResult.tenantGuid,
            'packageGuid': '',
            'licenseTypeId': productArrResult.LicenseTypeId,
            ...modalFields
        }];

        try {
            addTenantPackage(inputArr)
                .then((response) => {
                    let responseObj = response.data.dataObject;
                    // let inputArr = [];
                    let newObj = {
                        'locationGuid': responseObj.locationGuid,
                        'productGuid': responseObj.productGuid,
                        'tierGuid': responseObj.tierGuid,
                        'licenseCount': responseObj.licenseCount,
                        'userGuid': responseObj.modifiedBy,
                        'tenantGuid': responseObj.tenantGuid,
                        'packageGuid': responseObj.packageGuid,
                        'licenseTypeId': responseObj.licenseTypeId
                    }

                    inputFields.push(newObj);
                    setInputFields(inputFields);

                    let finalMessage = response.data.message;
                    setAlertType('SUCCESS');
                    setAlertMessage(finalMessage);
                    setModal(false);
                })
                .catch((err) => {
                    console.log('package add++++++++++++++ err', err);
                    let errMessage = err.response.data.message.trim();
                    let locationGuid = errMessage.slice(errMessage.lastIndexOf(' ') + 1);
                    let locationName = locationArr.find(element => element.value.toUpperCase() === locationGuid.toUpperCase()).display;
                    let newMsg = errMessage.substring(0, errMessage.lastIndexOf(" "));

                    let finalMessage = newMsg + ' ' + locationName;
                    setAlertType('ERROR');
                    setAlertMessage(finalMessage);
                    setModal(false);
                });
        }
        catch (err) {
            console.log('err++++++++++++', err);
        }
    }

    const getPackage = async (tenantGuid) => {
        try {
            let inputArr = [];
            purchaseArr = await getTenantPackage(tenantGuid);
            inputArr = purchaseArr.map((elmt) => {
                return {
                    locationGuid: elmt.locationGuid,
                    productGuid: elmt.productGuid,
                    tierGuid: elmt.tierGuid,
                    licenseCount: elmt.licenseCount,
                    userGuid: elmt.modifiedBy,
                    tenantGuid: elmt.tenantGuid,
                    packageGuid: elmt.packageGuid,
                    licenseTypeId: elmt.licenseTypeId
                }
            }
            );
            setInputFields(inputArr);
            setServerData(purchaseArr);
        } catch (error) {
            console.log('getPackage error', error);
        }
    }

    const getLocations = async () => {
        try {
            let response = await getLocation();
            let branchResult = response.data.getBranch.map(value => {
                return { value: value.GroupGuid, display: value.OfficeName }
            });
            let result = [{ value: '', display: 'Select Location' }].concat(branchResult);
            setLocations(result);
        } catch (error) {
            console.log('getBranch error', error);
        }
    }

    const getTier = async () => {
        try {
            let response = await getTenantTier();
            let tierFromApi = response.map(value => {
                return { value: value.TierGuid, display: value.TierName }
            });

            let resultArr = [{ value: '', display: 'Select Tier' }].concat(tierFromApi);
            setTier(resultArr);
        } catch (error) {
            console.log('getTier error', error);
        }
    }

    const getProduct = async () => {
        try {
            let response = await getTenantProduct();
            let result = response.map(value => {
                return { value: value.ProductGuid, display: value.ProductName, LicenseTypeId: value.LicenseTypeId }
            });

            let resultArr = [{ value: '', display: 'Select Product' }].concat(result);
            setProduct(resultArr);
        } catch (error) {
            console.log('getProduct error', error);
        }
    }

    const handleInputChange = (index, event) => {
        const values = [...inputFields];
        values[index][event.target.name] = event.target.value;

        if (event.target.name === 'productGuid') {
            let productArrResult = productArr.find(element => element.value.toUpperCase() === event.target.value.toUpperCase());
            values[index]['licenseTypeId'] = productArrResult.LicenseTypeId;
        }

        setInputFields(values);
    };

    const licenceIncrement = (index, e) => {
        const values = [...inputFields];
        let oldVal = values[index].licenseCount;
        values[index].licenseCount = oldVal + 1;
        setInputFields(values);
    }

    const licenceDecrement = (index, e) => {
        const values = [...inputFields];
        let oldVal = values[index].licenseCount;

        if (oldVal > 0) {
            values[index].licenseCount = oldVal - 1;
        }
        else {
            values[index].licenseCount = 0;
        }
        setInputFields(values);
    }

    const handleRemoveFields = async (index, e, packageGuid) => {

        try {
            e.preventDefault();
            clearAlertType();
            const values = [...inputFields];
            if (packageGuid.length === 0) {
                values.splice(index, 1);
                setInputFields(values);
            } else {
                deleteTenantPackage(packageGuid)
                    .then((response) => {
                        let finalMessage = response.data.message;
                        setAlertType('SUCCESS');
                        setAlertMessage(finalMessage);
                        values.splice(index, 1);
                        setInputFields(values);
                        setConfirmModal(false);
                    })
                    .catch((err) => {
                        console.log('tenant update err', err);
                        setConfirmModal(false);
                    });
            }
        } catch (err) {
            console.log('error', err.response);
        }

    };

    // const handleSubmit = async (e) => {
    //     try {
    //         e.preventDefault();
    //         let tenantResult = props.auth.tenantResult;
    //         let result = [];

    //         serverData = serverData.map((elmt) => {
    //             return {
    //                 locationGuid: elmt.locationGuid,
    //                 productGuid: elmt.productGuid,
    //                 tierGuid: elmt.tierGuid,
    //                 licenseCount: elmt.licenseCount,
    //                 userGuid: elmt.modifiedBy,
    //                 tenantGuid: elmt.tenantGuid,
    //                 packageGuid: elmt.packageGuid
    //             }
    //         });

    //         console.log("inputFields", inputFields);
    //         console.log("serverData", serverData);

    //         if (serverData.length) {
    //             result = inputFields.filter(function (val) {
    //                 return serverData.indexOf(val) === -1;
    //             });
    //         } else {
    //             result = [...inputFields];
    //         }

    //         console.log('result+++++++++++++', result);

    //         if (result.length > 0) {

    //             tenantResult.productCount = tenantResult.productCount + 1;

    //             //Insert into history table.
    //             // let historyData = {
    //             //     "tenantGuid": this.state.tenantGuid,
    //             //     "userGuid": this.props.auth.tenantUserGuid,
    //             //     "masterId": 1,
    //             //     "count": 1,
    //             //     "licenseTypeGuid": ''
    //             // }

    //             // let insertIntoHistoryTblUrl = 'https://i7o2a0a8n5.execute-api.ap-south-1.amazonaws.com/production/tenantIdentity/insertIntoHistoryTbl';
    //             // await axios.post(insertIntoHistoryTblUrl, historyData);

    //             //Update Language Count in Tenant table.
    //             let tenantUpdateData = {
    //                 "tenantGuid": tenantResult.tenantGuid,
    //                 "companyName": tenantResult.companyName,
    //                 "userPoolName": tenantResult.userPoolName,
    //                 "identityPoolId": tenantResult.identityPoolId,
    //                 "clientId": tenantResult.clientId,
    //                 "region": tenantResult.region,
    //                 "isPurchase": tenantResult.isPurchase,
    //                 "locationCount": tenantResult.locationCount,
    //                 "productCount": tenantResult.productCount,
    //                 "webLicenseCount": tenantResult.webLicenseCount,
    //                 "pdaLicenseCount": tenantResult.pdaLicenseCount,
    //                 "userPoolId": tenantResult.userPoolId,
    //                 "languageCount": tenantResult.languageCount
    //             }

    //             let updateTenantUrl = 'https://i7o2a0a8n5.execute-api.ap-south-1.amazonaws.com/production/tenantIdentity/updateTenant';
    //             axios.put(updateTenantUrl, tenantUpdateData)
    //                 .then((response) => {

    //                     let Url = 'https://i7o2a0a8n5.execute-api.ap-south-1.amazonaws.com/production/tenantIdentity/package';
    //                     axios.post(Url, result)
    //                         .then((response) => {
    //                             alert(response.data.message);
    //                             setInputFields(inputFields);
    //                         })
    //                         .catch((err) => {
    //                             console.log('package add++++++++++++++ err', err.response);

    //                             let errMessage = err.response.data.message.trim();
    //                             let locationGuid = errMessage.slice(errMessage.lastIndexOf(' ') + 1);
    //                             let locationName = locationArr.find(element => element.value.toUpperCase() === locationGuid.toUpperCase()).display;
    //                             let newMsg = errMessage.substring(0, errMessage.lastIndexOf(" "));

    //                             alert(newMsg + ' ' + locationName);
    //                         });
    //                 })
    //                 .catch((err) => {
    //                     console.log('tenant update err', err);
    //                 });
    //         }
    //     } catch (err) {
    //         console.log('error', err);
    //     }
    // };

    const handleModalClose = event => {
        setModal(false);
    };

    const handleModalOpen = event => {
        setModal(true);
    };

    const handleConfirmModalClose = event => {
        setConfirmModal(false);
    };

    const handleConfirmModalOpen = event => {
        setConfirmModal(true);
    };

    const navigate = (e) => {
        clearAlertType();
        let result = inputFields.map(({ locationGuid, productGuid }) => ({ locationGuid, productGuid }));

        const filteredArr = result.reduce((acc, current) => {
            const x = acc.find(item => item.locationGuid === current.locationGuid &&
                item.productGuid === current.productGuid);
            if (!x) {
                return acc.concat([current]);
            } else {
                return acc;
            }
        }, []);

        if (inputFields.length > 0) {
            if (filteredArr.length !== inputFields.length) {
                setAlertType('ERROR');
                setAlertMessage('Duplicate Product and location mapping exist.');

            } else {
                addTenantPackage(inputFields)
                    .then((response) => {
                        let finalMessage = response.data.message;
                        setAlertType('SUCCESS');
                        setAlertMessage(finalMessage);
                        setInputFields(inputFields);
                        props.history.push('/Purchases');
                    })
                    .catch((err) => {
                        let errMessage = err.response.data.message.trim();
                        let locationGuid = errMessage.slice(errMessage.lastIndexOf(' ') + 1);
                        let locationName = locationArr.find(element => element.value.toUpperCase() === locationGuid.toUpperCase());
                        let newMsg = errMessage.substring(0, errMessage.lastIndexOf(" "));

                        let finalMessage = newMsg + ' ' + locationName;
                        setAlertType('ERROR');
                        setAlertMessage(finalMessage);
                        setAlertType('')
                    });
            }

        } else {
            setAlertType('ERROR');
            setAlertMessage('Please add Product');
            e.preventDefault();
        }
    }

    return (
        <fieldset>
            <main className="Dash-board">
                <div className="Dash-board-div">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <SideBar {...props} />
                            </div>
                            <div className="col-md-9">
                                <Header {...props} />
                                <div className="content-sec">
                                    {
                                        alert_type === 'SUCCESS' ? (<SuccessAlert message={alert_message} />) : null
                                    }

                                    {
                                        alert_type === 'ERROR' ? (<ErrorAlert message={alert_message} />) : null
                                    }


                                    <Fragment>
                                        <div className="purchase-content">
                                            {/* <div onClick={(e) => handleAddFields(e)} className="purchase-pack-add"><img src={add_box} alt="" />Add Another Package</div> */}

                                            <div className="purchase-text">{t('PRODUCTS AND PLANS')}</div>
                                            <div className="purchase-pack-add" onClick={handleModalOpen}><img src={add_box} alt="" /><span>{t('Add Another Product')}</span></div>
                                        </div>
                                        {
                                            (productArr.length > 0 && locationArr.length > 0 && tierArr.length > 0) ? (
                                                <form id="package-form" autoComplete="off" action="" onSubmit={navigate}>
                                                    {inputFields.map((inputField, index) => (
                                                        <Fragment key={`${inputField}~${index}`}>
                                                            <div className="purchase-package">
                                                                <div className="package-header">
                                                                    <h3>{t('PACKAGE')} {index + 1}</h3>
                                                                    <div onClick={handleConfirmModalOpen} className="delete"><img src={deleteImg} alt="" /></div>
                                                                </div>
                                                                <div className="d-md-flex">
                                                                    <div className="align-control">
                                                                        <div className="chose-location location-opacity">
                                                                            <label>{t('Choose Location')}</label>
                                                                            <select required className="form-control" name="locationGuid" value={inputField.locationGuid}
                                                                                onChange={event => handleInputChange(index, event)} disabled>
                                                                                {locationArr && locationArr.map((elmt) => <option key={elmt.value} value={elmt.value}>{t(`${elmt.display}`)}</option>)}
                                                                            </select>
                                                                        </div>
                                                                        <div className="note">
                                                                            {/* <p>{t('NOTE: Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur auctor pharetra maximus.')}</p> */}

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="d-md-flex">
                                                                    <div className="align-control">
                                                                        <div className="chose-product location-opacity">
                                                                            <label>{t('Choose Products')}</label>
                                                                            <select required className="form-control" disabled name="productGuid" value={inputField.productGuid}
                                                                                onChange={event => handleInputChange(index, event)}>
                                                                                {productArr && productArr.map((elmt) => <option key={elmt.value} value={elmt.value}>{t(`${elmt.display}`)}</option>)}
                                                                            </select>
                                                                        </div>
                                                                        <div className="chose-plan">
                                                                            <label>{t('Choose Plan')}</label>
                                                                            <select required className="form-control" name="tierGuid" value={inputField.tierGuid}
                                                                                onChange={event => handleInputChange(index, event)}>
                                                                                {tierArr && tierArr.map((elmt) => <option key={elmt.value} value={elmt.value}>{t(`${elmt.display}`)}</option>)}
                                                                            </select>
                                                                        </div>
                                                                        <div className="number-row">
                                                                            <label>{t('Number of licenses required')}:</label>
                                                                            <div className="numbers-row">
                                                                                <input type="text" name="licenseCount" value={inputField.licenseCount} className="form-control number-count"
                                                                                    id="turtle-doves" onChange={event => handleInputChange(index, event)} />
                                                                                <div className="inc button" onClick={event => licenceIncrement(index, event)}>+</div>
                                                                                <div className="dec button" onClick={event => licenceDecrement(index, event)}>-</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <Modal
                                                                    isOpen={isConfirmModalOpen}
                                                                    onRequestClose={handleConfirmModalClose}
                                                                    contentLabel="My Confirm dialog"
                                                                    style={{
                                                                        overlay: {
                                                                            position: 'fixed',
                                                                            top: 0,
                                                                            left: 0,
                                                                            right: 0,
                                                                            bottom: 0
                                                                        },
                                                                        content: {
                                                                            position: 'unset',
                                                                            top: '0px',
                                                                            left: '40px',
                                                                            right: '40px',
                                                                            bottom: '40px',
                                                                            border: 'none',
                                                                            background: 'none',
                                                                            overflow: 'hidden',
                                                                            WebkitOverflowScrolling: 'touch',
                                                                            borderRadius: '4px',
                                                                            outline: 'none',
                                                                            padding: '0px'
                                                                        }
                                                                    }}>
                                                                    <div className="modal-dialog delete-dialog">
                                                                        <div className="modal-content">
                                                                            <div className="modal-header">
                                                                                <h5 className="modal-title">{t('Are you sure you want to delete?')}</h5>
                                                                                <button type="button" className="close" onClick={handleConfirmModalClose}>
                                                                                    <span><img src={close_black} alt="" /></span>
                                                                                </button>
                                                                            </div>
                                                                            <div className="modal-body">
                                                                                <div className="row">
                                                                                    <div className="col-md-12">
                                                                                        <h5 className="modal-title">{t("This item will be deleted immediately. You can't undo this action.")}</h5>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="modal-footer">
                                                                                <button type="button" onClick={handleConfirmModalClose} className="btn btn-secondary" data-dismiss="modal">{t('CANCEL')}</button>
                                                                                <button type="submit" onClick={(e) => handleRemoveFields(index, e, inputField.packageGuid)} className="btn btn-primary" >{t('CONFIRM')}</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Modal>
                                                            </div>
                                                        </Fragment>
                                                    ))}
                                                </form>
                                            ) : (<img src={loader} alt="" className="loader" />)
                                        }

                                        <div className="bottom-button">
                                            <button type="button" className="btn btn-secondary" onClick={() => { props.history.push('/Location') }}>{t('BACK')}</button>
                                            <button type="button" className="btn btn-primary" onClick={navigate} >{t('NEXT')}</button>
                                        </div>
                                    </Fragment>
                                </div>

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>


                <Modal
                    isOpen={isModalOpen}
                    onRequestClose={handleModalClose}
                    contentLabel="My dialog"
                    style={{
                        overlay: {
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            // backgroundColor: 'rgba(0, 0, 0, 0.75)'
                        },
                        content: {
                            position: 'unset',
                            top: '0px',
                            left: '40px',
                            right: '40px',
                            bottom: '40px',
                            border: 'none',
                            background: 'none',
                            overflow: 'hidden',
                            WebkitOverflowScrolling: 'touch',
                            borderRadius: '4px',
                            outline: 'none',
                            padding: '0px'
                        }
                    }}>
                    <div className="modal-dialog add-new-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{t('Add New Product')}</h5>
                                <button type="button" className="close" onClick={handleModalClose}>
                                    <span><img src={close_black} alt="" /></span>
                                </button>
                            </div>
                            <form autoComplete="off" onSubmit={addPackage}>
                                <div className="modal-body">
                                    <div className="row ">
                                        <div className="col-md-6">
                                            <label className="icon">{t('Choose Products')}</label>
                                            <select required className="form-control" name="productGuid"
                                                onChange={handleChange}>
                                                {productArr && productArr.map((elmt) => <option key={elmt.value} value={elmt.value}>{t(`${elmt.display}`)}</option>)}
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="icon">{t('Choose Plan')}</label>
                                            <select required className="form-control plan-selct" name="tierGuid"
                                                onChange={handleChange}>
                                                {tierArr && tierArr.map((elmt) => <option key={elmt.value} value={elmt.value}>{t(`${elmt.display}`)}</option>)}
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="icon">{t('Choose Location')}</label>
                                            <select required className="form-control" name="locationGuid"
                                                onChange={handleChange}>
                                                {locationArr && locationArr.map((elmt) => <option key={elmt.value} value={elmt.value}>{t(`${elmt.display}`)}</option>)}
                                            </select>
                                        </div>
                                        <div className="col-md-6 license-count-cntrl">
                                            <label>{t('Licenses required')}:</label>

                                            <input type="text" name="licenseCount" className="form-control number-count" value={modalFields.licenseCount}
                                                id="turtle-doves" onChange={handleChange} />
                                            <div className="inc button" onClick={increment}>+</div>
                                            <div className="dec button" onClick={decrement}>-</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    {/* <div>{t('Learn more')}</div> */}
                                    <button type="button" onClick={handleModalClose} className="btn btn-secondary" data-dismiss="modal">{t('CANCEL')}</button>
                                    <button type="submit" className="btn btn-primary" >{t('OK')}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </Modal>

            </main>
        </fieldset>
    );
}

export default Products;
